
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blockquiry_connect/GIMS/interactive_report_new",
      function () {
        return require("private-next-pages/blockquiry_connect/GIMS/interactive_report_new.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blockquiry_connect/GIMS/interactive_report_new"])
      });
    }
  